import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getBarrarEntrega = createAsyncThunk(
  "transportadorasApp/barrarEntrega/getBarrarEntrega",
  async (data: object, { dispatch }) => {
    let response;
    dispatch(openLoading());
    try {
      response = await API.get("/barrar/entrega", { params: data });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return response.data;
  }
);

export const saveConfigBarrarEntrega = createAsyncThunk(
  "transportadorasApp/barrarEntrega/saveConfigBarrarEntrega",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    dispatch(openLoading());
    try {
      await API.post("/barrar/entrega", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Configuração cadastrada",
        })
      );
      dispatch(
        getBarrarEntrega(
          requestGetParams.transportadorasApp.barrarEntrega.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível salvar!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return {};
  }
);

export const updateConfigBarrarEntrega = createAsyncThunk(
  "transportadorasApp/barrarEntrega/updateConfigBarrarEntrega",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    dispatch(openLoading());
    try {
      await API.put(`/barrar/entrega/${data.apelidoTransportadora}`, data);
      dispatch(
        openToast({
          severity: "success",
          title: "Configuração atualizada",
        })
      );
      dispatch(
        getBarrarEntrega(
          requestGetParams.transportadorasApp.barrarEntrega.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível atualizar configuração!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return {};
  }
);

export const deleteConfigBarrarEntrega = createAsyncThunk(
  "transportadorasApp/barrarEntrega/deleteConfigBarrarEntrega",
  async (apelidoTransportadora: string, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    dispatch(openLoading());
    try {
      await API.delete(`/barrar/entrega/${apelidoTransportadora}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Configuração excluída com sucesso",
        })
      );
      dispatch(
        getBarrarEntrega(
          requestGetParams.transportadorasApp.barrarEntrega.requestGetParams
        )
      );
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível excluir a configuração!",
          text: "Se certifique que os dados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return {};
  }
);
